import { reqQbData } from '../../../static/utils/get-qb-data';
import { addKey, ubcClickInit } from '../../../static/utils/ubcMethods';
import { formatNumEn, getCurrentUrlfrFunc, processReplyEntry } from '../../qalandpage/utils/util';
import { setAuthorInfo, foldText, setNumThousands } from '../../qalandpage/utils/formatQuestion';
import { getAppInstalled } from '../../qalandpage/utils/getAppinstalled';
import { getSupport } from '../../qalandpage/utils/localstorage';
import { act } from '../../../static/utils/navigate';
import { request } from '../../../static/utils/request';
import { reqPathTo } from '../../../static/utils/env';
import log from '../../../static/utils/ubcLog';
import { getSearchQuery, createCtk } from '../../../static/utils/index';

/* globals getApp swan getCurrentPages */

/**
 * eid 处理
 *
 * @param {Object} adsEids 后端返回的 adsEids 字段
 * @return {number}
 */

function processEid(adsEids) {
  let adsEid = '';
  if (adsEids && adsEids.asp && adsEids.asp.length) {
    adsEid = adsEids.asp[0];
    addKey({
      'ads_eid': adsEid
    });
  }
  return +adsEid;
}
function processNowReplies(nowReplies) {
  const repliesss = [];
  const threadIdArr = [];
  let firstAnimate = false;
  let videoList = [];
  nowReplies.length && nowReplies.forEach(item => {
    item = setAuthorInfo(item, 'question');
    item = foldText(item, 75);
    // 赞踩支持未登录，从接口或者本地缓存获取赞踩状态
    item = getSupport(item);
    item.bit_pack.comment_flag && threadIdArr.push(item.threadId);
    if (item.goodValueNum === 0 && !firstAnimate) {
      firstAnimate = true;
      item.firstAnimate = true;
    }
    if (item.videoList && item.videoList.length) {
      item.videoList.forEach(video => {
        video.user = item.user;
        video.topic && (video.topic.topicPlayNum = formatNumEn(video.topic.topicPlayNum));
      });
      videoList = [...videoList, ...item.videoList];
    }
    item.replyType = 'replies';
    repliesss.push(item);

    // reply_entry处理
    processReplyEntry(item, 'question');
  });
  return [repliesss, threadIdArr, firstAnimate, videoList, false];
}
export default {
  /**
   * ready回调
   *
   * @return
   */
  ready() {
    if (this.loaded || this.showErr) {
      this.hideSkeleton();
    }
  },
  /**
   * mount回调
   *
   * @return
   */
  mount() {
    this.entireHeight = 44;
  },
  /**
   * init回调
   *
   * @param {query} object 页面url参数
   * @return
   */

  init(query) {
    let queryInfo = this.queryHandler(query);
    this.preGetQbData(queryInfo);
  },
  /**
   * query 处理
   */
  queryHandler(query) {
    query = query || {};
    let {
      cid
    } = query;
    query = {
      ...query,
      qid: cid
    };
    this.queryData = query;
    return query;
  },
  /**
   * 重置页面
   *
   * @param {query} object 页面url参数
   * @return
   */
  resetPage() {
    // 刷新时将notry重置
    this.preGetQbData(this.queryData);
  },
  /**
   * 小程序获取广告数据的处理
   *
   * @param {object} data question接口返回参数
   * @param {object} question question信息
   * @return
   */
  getRelAdsBefore(data, question) {
    let me = this;
    return new Promise(resolve => {
      getAppInstalled({
        callback: res => {
          data.iadlist = res.iadlist;
          let adsData = me.getRelAds(data, question);
          resolve(adsData);
        }
      });
    });
  },
  /**
   * 数据处理
   */

  processQbData(res, resolve) {
    if (res && res.errno !== 0 || !res.question || res.question && !res.question.title) {
      this.showErr = true;
      this.errMsg = '网络问题，请稍候再试';
      this.hideSkeleton();
      log.send && log.send({
        serverId: 16206,
        area: 'question_request_error',
        action: 'show',
        errorMsg: 'not-data'
      });
      return;
    }
    let {
      question = {}
    } = res;
    let adsEid = processEid(res.adsEids);
    let title = question.title;
    // 首次setData的值
    let datatoSet = {};
    question.samphit = res.evaSampling && res.evaSampling.samplowVal;
    question.contentText = question.contentText && question.contentText.replace(/<\/?[^>]*>/g, '').replace(/(\n)/g, '').replace(' ', '');
    question.supplyText = question.supplyText && question.supplyText.replace(/<\/?[^>]*>/g, '').replace(/(\n)/g, '').replace(' ', '');
    // 标记最佳回答
    let dataNewbest = res.singleReply ? [] : res.newbest || [];
    const dataReplies = res.replies || [];
    const nowReplies = [...dataNewbest, ...dataReplies][0] || {};
    let lawClueConfigImageUrl = res.lawClueConfig && res.lawClueConfig.imageUrl || '';
    // 处理回答
    let [repliesss,
    // threadIdArr,
    firstAnimate,
    // videoList,
    hasSendUserTagLog] = processNowReplies(nowReplies);
    datatoSet.isLaw = question.bit_pack && question.bit_pack.is_law > 0;
    if (datatoSet.isLaw) {
      datatoSet.onlioneLawyerNum = +res.onlioneLawyerNum || 0;
      datatoSet.onlioneConsultants = res.onlioneConsultants || 0;
      addKey({
        'isLawQuestion': datatoSet.isLaw ? 1 : 0,
        'isFromLawMigration': question.ext_pack && question.ext_pack.is_from_law_migration || 0,
        'importId': question.import_id,
        'hasVideo': datatoSet.replies[0] && datatoSet.replies[0].videoList && datatoSet.replies[0].videoList.length > 0 ? 1 : 0
      });
    }
    // 判断是否是【法律法规】页面
    if (question.bit_pack && question.bit_pack.is_law_regulation > 0) {
      datatoSet.isLawRegulation = true;
    }
    datatoSet.importId = question.import_id;
    // 跳转链接
    datatoSet.botJumpUrl = res && res.lawClueConfig && res.lawClueConfig.botJumpUrl || '';
    // 托管标识title
    const hostedTitle = question.ext_pack && question.ext_pack.title;
    {
      document.title = title + '-' + (hostedTitle || '律临');
      const metaList = document.getElementsByTagName('meta');
      const textArr = repliesss && repliesss[0] && repliesss[0].contentText && repliesss[0].contentText.split('。') || [];
      for (let i = 0; i < metaList.length; i++) {
        if (metaList[i].getAttribute('name') === 'description') {
          metaList[i].content = textArr[0];
        }
      }
    }
    // 托管内容是否需要分润
    const isFenrun = question.ext_pack && question.ext_pack.is_fenrun === 1;
    addKey({
      title: title || ''
    });
    log.send && log.send({
      serverId: 16206,
      area: 'all_show',
      action: 'show'
    });
    this.asyncSetData({
      // 标志着首屏渲染数据setData完成，可以收起骨架屏幕并展示内容
      loaded: true,
      showErr: false,
      isFenrun,
      nowReplies,
      question,
      lawClueConfigImageUrl,
      ...(adsEid && {
        adsEid
      }),
      ...(repliesss.length === 1 && {
        replyAsk: repliesss[0].replyAsk ? repliesss[0].replyAsk : {}
      }),
      ...datatoSet
    });
    resolve({
      title
    });
  },
  /**
   * 渲染数据
   * @param data {Object} 要渲染的数据
   * @param next {Function} 提交渲染数据后下一个时间片执行的内容
   * @return {Promise} 渲染完成的Promise
   */

  asyncSetData(data, next) {
    return new Promise(resolve => {
      Object.assign(this, data);
      this.hideSkeleton();
      resolve();
      this.$nextTick(() => {
        typeof next === 'function' && next();
      });
    });
  },
  /**
   * 提前请求核心数据
   * @param query {Object} 页面url中的query
   * @param data {Object} 请求参数
   */

  preGetQbData(query) {
    return new Promise(resolve => {
      reqQbData({
        query: query,
        data: {}
      }).then(res => {
        query.hitEid = res.data && res.data.adsEids && res.data.adsEids.asp && res.data.adsEids.asp[0] || 0;
        this.getRelAdsBefore(query, res.data && res.data.question || {}).then(values => {
          Object.assign(this, {
            ...((values || {}).datatoset || {}),
            isFMPLoaded: true
          });
        }).catch(() => {});
        this.processQbData(res.data, resolve);
      }).catch(error => {
        this.errorLog(error);
        this.hideSkeleton();
      });
    });
  },
  // 数据请求异常打点
  errorLog(error) {
    log.send && log.send({
      serverId: 16206,
      area: 'question_request_error',
      action: 'show',
      errorMsg: error && JSON.stringify(error)
    });
  },
  /**
   * 返回首页
   *
   * @return
   */

  tohome() {
    ubcClickInit({
      value: 'law-regulation-err-gohome'
    });
    act({
      target: '/pages/home/index?fr=qbPage',
      type: 'switch'
    });
  },
  /**
   * 隐藏骨架屏
   *
   * @return
   */

  hideSkeleton() {
    this.$mpUpdated().then(() => {
      this.$mp && this.$mp.scope && this.$mp.scope.removeSkeleton && this.$mp.scope.removeSkeleton();
    });
  },
  /**
   * 小程序获取广告数据
   *
   * @param {object} data question接口返回参数
   * @param {object} question qid信息
   * @return
   */
  getRelAds(data, question = {}) {
    return new Promise(resolve => {
      resolve({});

      // 获取搜索传过来的fr, 判断首答是否折叠实验

      // 优先从搜索侧的sessionId中获取lid
    });
  }
};